import { useMemo } from 'react';
import { useKeysContext } from './useKeysContext';
import { IKeysBlankNames } from '../constants/pragerohlinge';
import { IKeySideName } from '../store/keysTypes';
import { KeysPaginationHook } from '../contexts/KeysContextTypes';

export const useKeysPagination = (): KeysPaginationHook => {
  const { state, dispatch } = useKeysContext();
  const { page, selectedKeyTypes, enabledTabIds } = state;

  const selectedKeysArray = useMemo(() => {
    return Object.values(selectedKeyTypes).flat();
  }, [selectedKeyTypes]);

  const nextPage = (newPage: number) => {
    dispatch({ type: 'SET_PAGE', payload: newPage });
    dispatch({ type: 'ENABLE_TAB', payload: newPage });
  };

  const onChangeTab = (newVal: number) => {
    if (page > newVal) {
      validatePreviousPage(newVal);
      return;
    }
    nextPage(newVal);
  };

  const validateNextPage = (newPage: number) => {
    switch (page) {
      case 1: {
        if (selectedKeysArray.length) {
          nextPage(newPage);
        }
        break;
      }
      case 2: {
        const unvisitedKey = selectedKeysArray.find((item) => !item.visited);
        const blank = unvisitedKey?.blank;
        
        if (unvisitedKey && blank) {
          dispatch({ type: 'SET_SELECTED_KEY_ID', payload: unvisitedKey.id });
          
          if (blank === IKeysBlankNames.FA || blank === IKeysBlankNames.OV) {
            selectedKeyTypes[blank].forEach((item, index) => {
              dispatch({
                type: 'SET_VISITED',
                payload: {
                  keyIndex: index,
                  visited: true,
                  blank: blank,
                },
              });
            });
            break;
          }
          
          const keyIndex = selectedKeyTypes[blank].findIndex((item) => !item.visited);
          dispatch({
            type: 'SET_VISITED',
            payload: {
              keyIndex,
              visited: true,
              blank: unvisitedKey.blank,
            },
          });
          break;
        }

        if (!unvisitedKey) {
          nextPage(newPage);
        }
        break;
      }
      case 3: {
        if (selectedKeysArray.length) {
          nextPage(newPage);
        }
        break;
      }
    }
  };

  const validatePreviousPage = (newPage: number) => {
    enabledTabIds.forEach((item) => {
      if (item > newPage) {
        dispatch({ type: 'DISABLE_TAB', payload: item });
      }
    });
    
    if (newPage === 1 || newPage === 2) {
      selectedKeysArray.forEach((item) => {
        const itemIndex = selectedKeyTypes[item.blank].findIndex(key => item.id === key.id);
        dispatch({
          type: 'SET_SCREENSHOT_READY',
          payload: { keyIndex: itemIndex, blank: item.blank, side: IKeySideName.FRONT, value: false },
        });
        dispatch({
          type: 'SET_SCREENSHOT_READY',
          payload: { keyIndex: itemIndex, blank: item.blank, side: IKeySideName.BACK, value: false },
        });
      });
    }
    
    nextPage(newPage);
  };

  const onBack = () => {
    validatePreviousPage(page - 1);
  };

  const onForward = () => {
    validateNextPage(page + 1);
  };

  return {
    onChangeTab,
    onBack,
    onForward,
    disablePagination: !selectedKeysArray.length,
    disableForward: !selectedKeysArray.length,
  };
};